"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./ExpandableFade.css");
var debounce = require("lodash.debounce");
var LDDebounce = debounce;
// From: https://jira.csod.com/browse/CSOD-78013
var HeightConstants = {
    Small: '60px',
    Large: '180px'
};
/**
 * @see ExpandableFadeProps
 */
var ExpandableFade = /** @class */ (function (_super) {
    __extends(ExpandableFade, _super);
    function ExpandableFade(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false,
            isMoreShown: false,
            openContainerHeight: '0px'
        };
        _this.toggleState = _this.toggleState.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this._resizedDebounce = LDDebounce(_this._resized.bind(_this), 200);
        return _this;
    }
    ExpandableFade.prototype._resized = function () {
        this.updateHeightCalc();
    };
    ExpandableFade.prototype.toggleState = function () {
        var _this = this;
        this.setState({
            isOpen: !this.state.isOpen
        }, function () {
            /** Focus toggled content */
            if (_this.state.isOpen) {
                _this.contentRef.focus();
            }
            if (_this.props.onToggle) {
                _this.props.onToggle(_this.state.isOpen);
            }
        });
    };
    ExpandableFade.prototype.handleKeyPress = function (event) {
        if (event.charCode === 13 || event.keyCode === 13) {
            this.toggleState();
        }
    };
    ExpandableFade.prototype.componentDidMount = function () {
        this.updateHeightCalc();
        this.setToggleVisibility();
        window.addEventListener('resize', this._resizedDebounce);
        if (this.props.defaultOpen) {
            this.expandVisibility();
        }
    };
    ExpandableFade.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this._resizedDebounce);
        this._resizedDebounce.cancel();
    };
    ExpandableFade.prototype.componentDidUpdate = function (prevProps) {
        this.updateHeightCalc();
        if (prevProps.children !== this.props.children) {
            this.setToggleVisibility();
        }
    };
    ExpandableFade.prototype.updateHeightCalc = function () {
        var height = this.contentRef.clientHeight + 'px';
        if (this.state.openContainerHeight !== height) {
            this.setState({ openContainerHeight: height });
        }
    };
    ExpandableFade.prototype.setToggleVisibility = function () {
        this.setState({
            isMoreShown: this.contentRef.clientHeight > this.heightAsNumber
        });
    };
    ExpandableFade.prototype.expandVisibility = function () {
        this.setState({
            isOpen: true,
            isMoreShown: true
        });
    };
    ExpandableFade.prototype.render = function () {
        var _this = this;
        var currentText = this.state.isOpen ? this.props.lessLabel : this.props.moreLabel;
        var currentAriaText = this.state.isOpen ? this.props.lessAriaLabel : this.props.moreAriaLabel;
        var expandClass = ['p-expandable-fade'];
        this.props.maxHeight && expandClass.push('has-max-height');
        expandClass.push(this.state.isOpen ? 'isExpanded' : 'isMinimized');
        var closedHeight = '0px';
        if (this.props.height) {
            closedHeight = HeightConstants[this.props.height];
        }
        if (this.props.customHeight) {
            closedHeight = this.props.customHeight;
        }
        var contentStyles = this.props.maxHeight
            ? {
                maxHeight: this.state.isOpen ? this.props.maxHeight : closedHeight
            }
            : {
                height: this.state.isOpen ? this.state.openContainerHeight : closedHeight
            };
        this.heightAsNumber = parseInt(closedHeight, 10);
        var contentFadeClasses = ['content-fade'];
        if (this.props.backgroundColor) {
            contentFadeClasses.push(this.props.backgroundColor.toLowerCase());
        }
        return (React.createElement("div", { className: expandClass.join(' '), "data-tag": this.props.tag || null, "aria-expanded": this.state.isOpen },
            React.createElement("div", { className: "content", style: contentStyles, tabIndex: -1, "aria-hidden": !this.state.isOpen },
                React.createElement("div", { className: "expanded-content", tabIndex: -1, ref: 
                    /* istanbul ignore next */ function (ref) {
                        _this.contentRef = ref;
                    } }, this.props.children)),
            this.state.isMoreShown && (React.createElement("div", { className: contentFadeClasses.join(' ') },
                React.createElement("a", { tabIndex: 0, onKeyPress: this.handleKeyPress, onClick: this.toggleState, className: "p-link p-f-sz-d p-link-def p-t-full-hv-primary50 p-f-w-6", "aria-label": currentAriaText }, currentText)))));
    };
    ExpandableFade.defaultProps = {
        backgroundColor: 'White',
        moreLabel: '*More*',
        lessLabel: '*Less*'
    };
    return ExpandableFade;
}(React.Component));
exports.default = ExpandableFade;
//# sourceMappingURL=ExpandableFade.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/expandable-fade/build/control/ExpandableFade.js
// module id = 728
// module chunks = 0